module.exports = __webpack_public_path__ + "img/logo_hanhwa_life@3x.7e79ea3a.png";